<div class="business-pin-mobile-container">
	<app-kamona-layout [minHeight]="'calc(100vh - 196px)'">
		<div content>
			<ng-container *ngIf="loading else innerContentTemplate">
				<div class="vertically-centralized">
					<app-kamona-loading></app-kamona-loading>
				</div>

			</ng-container>
			<ng-template #innerContentTemplate>
				<div class="inner-content">
					<div>
						<app-kamona-phone-number-field [input]="phoneNumber">
						</app-kamona-phone-number-field>
					</div>
					<div class="m-t-16">
						<app-kamona-password-input [input]="password">
						</app-kamona-password-input>
					</div>
				</div>
			</ng-template>
		</div>
		<div *ngIf="!loading" footer>
			<div class="p-b-32">
				<div nz-row nzAlign="middle" nzGutter="15" nzJustify="space-between">
					<div nz-col nzSpan="24">
						<div class="kamona-button-session">
							<app-kamona-custom-button (submitForm)="submit()" [isBlock]="true"
													  [isDisabled]="!form.valid"
													  text="Next">
							</app-kamona-custom-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</app-kamona-layout>
</div>
